export class Resource {
  id: string;
}

export class NamedResource extends Resource {
  name: string;
}
